import script from "./currency-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./currency-input.vue?vue&type=script&setup=true&lang=ts"

import "./currency-input.vue?vue&type=style&index=0&id=3c250fb0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c250fb0"]])

export default __exports__